import React from "react";
import Header from"../components/header/header";
import Footer from "../components/footer/footer";
 // eslint-disable-next-line no-lone-blocks, no-unused-vars
   import { NavLink } from 'react-router-dom';



const Home = () => { 
  return ( 
  <header id="header">
     <Header /> 
     <div className="intro"> 
      <div className="overlay"> 
        <div className="container"> 
          <div className="row"> 
            <div className="col-xs-12 col-md-8 col-md-offset-2 intro-text"> 
              
              <h1> Delphia Paul </h1> 
              <br></br> 
              <br></br> 
              <p className="soustitre">
                Fleuriste *, décoratrice événementielle et paysagiste passionnée</p> 
                <br></br><br></br>
                <p className="soustitre1"> 
                  * Retrait sur rendez-vous à Chennevières sur Marne (94430)</p> 
                
<br></br><br></br>
   {/*    <NavLink
                           to="/exclusivité_du_moment" className="btn btn-custom btn-lg"
                         >
                                   Actualités du moment
                         </NavLink>  */}
                                
                  </div> 
                  </div> 
                  </div> 
                  </div> 
                  </div> 
                  <Footer /> 
                  </header>
                   );
                   };
                   
                   
                   export default Home;